module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editBankInsuranceForClient":"Edit bank insurance for client"},"al":{"editBankInsuranceForClient":"Modifiko Sigurim Bankar për klientin"}}')
  delete Component.options._Ctor
}
